import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';
import { getStringLength } from '@ajaibid/utils';

export const styStockBuySellContainer = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  > * {
    min-width: 300px;
  }
`;

export const styHeaderGrid = css`
  display: flex;
  flex-direction: column;

  > span {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const styBodyContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: scroll;
  overflow-x: visible;
`;

export const styFormContainer = css`
  padding: 12px;
  border: 1px solid ${colors.NEUTRAL_2};
  border-radius: 8px;
`;

export const styFormAccountTypePills = ({ multiplier }) => css`
  max-width: 50%;
  flex-grow: ${multiplier ? 1 : 10};

  > div {
    position: relative;

    ${multiplier && `padding-right: ${32 + getStringLength(multiplier) * 4}px;`}

    > * {
      font-size: 10px !important;
      text-align: left !important;

      span {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;

        border-radius: 12px 0px 0px 12px !important;
        font-size: 10px !important;
      }
    }
  }
`;

export const styMultiplierBadge = ({ type }) => css`
  display: flex;
  align-items: center;

  height: 20px;
  padding: 0px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;

  ${type === 'DAY_TRADING' &&
  `
    background: ${colors.YELLOW_6};
    color: ${colors.NEUTRAL_0};

    > svg > * {
      fill: ${colors.YELLOW_4};
    }
  `}
  ${type === 'MARGIN_TRADING' &&
  `
    background: linear-gradient(270deg, rgba(255, 255, 255, 0.2) -1.79%, rgba(0, 0, 0, 0) 100%),
      ${colors.SLATE_GRAY_7};
    color: ${colors.NEUTRAL_0};

    > svg > * {
      fill: ${colors.NEUTRAL_0};
    }
  `}
`;

export const styFormBpInsufficientRow = ({ show }) => css`
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, margin 0.3s ease-in-out;

  ${show &&
  `
    max-height: 60px;
    margin-bottom: 4px;
  `}

  > div {
    padding: 8px 0px;
    border-bottom: 1px solid ${colors.NEUTRAL_3};
  }
`;

export const styFormBpUnavailable = ({ show }) => css`
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, margin 0.3s ease-in-out;

  ${show &&
  `
    max-height: 60px;
    margin-top: 8px;
  `}
`;

export const styFormMtSuspendedCTA = css`
  display: flex !important;
  align-items: center !important;
  margin: 0px;

  color: ${colors.AJAIB_BLUE_5};
  svg,
  path {
    fill: ${colors.AJAIB_BLUE_5};
  }

  :hover {
    color: ${colors.AJAIB_BLUE_7};
    svg,
    path {
      fill: ${colors.AJAIB_BLUE_7};
    }
  }
`;

export const styFormInputThresholdBtn = css`
  box-sizing: border-box;
  height: 30px;
  padding: 0px 8px;

  > * {
    line-height: 28px !important;
  }
`;

export const styNotesContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const stySubmitBtnContainer = css`
  border-top: 2px solid ${colors.NEUTRAL_2};
`;

export const styConfirmationNotes = css`
  padding: 12px;
  border: 1px solid ${colors.NEUTRAL_2};
  border-radius: 8px;
`;

export const styConfirmationNotesList = css`
  padding-left: 16px;
  margin-bottom: 0;
`;
